import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod

 const PostRemoveMobilePanelConfiguration = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.RemoveMobilePanelConfiguration+"/"+data+"/delete",
   method: RequestType.DELETE,
   data,
 }); 
 const PutMobilePanelConfiguration  = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.UpdateMobilePanelConfiguration,
   method: RequestType.PUT,
   data, 
 }); 
 const CreateMobilePanelConfiguration  = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.CreateMobilePanelConfiguration,
   method: RequestType.POST,
   data, 
 }); 
 const CreateMobilePanelConfigurationV2  = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.CreateMobilePanelConfigurationV2,
   method: RequestType.POST,
   data, 
 }); 
 const FilterMobilePanelConfiguration  = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.FilterMobilePanelConfiguration,
   method: RequestType.POST,
   data, 
 }); 


 const MobilePanelConfigurationCommand = {
  PostRemoveMobilePanelConfiguration,
  PutMobilePanelConfiguration,
  CreateMobilePanelConfiguration,
  FilterMobilePanelConfiguration,
  CreateMobilePanelConfigurationV2
  
  }
  
  export default MobilePanelConfigurationCommand;